import styled from 'styled-components';

const DataToolsStyled = styled.div`
  /* padding: 24px 32px;
  min-height: 100%;
  background: #f5f5f5; */

  .page-header {
    margin-bottom: 24px;

    h1 {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin: 0 0 8px 0;
    }

    p {
      font-size: 14px;
      color: #999;
      margin: 0;
    }
  }

  .filter-section {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8e8e8;
    overflow: hidden;
    margin-bottom: 24px;
  }

  .filter-header {
    background: #fafafa;
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    gap: 8px;

    h2 {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin: 0;
    }
  }

  .filter-content {
    padding: 24px;
  }

  .filter-group {
    padding-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 24px;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .filter-item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .filter-label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 4px;

    .required {
      color: #f56c6c;
    }
  }

  .filter-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
  }

  .filter-radio-group {
    flex-direction: row;
    gap: 20px;
  }

  .filter-input,
  .filter-select {
    width: 320px;
  }

  .date-separator {
    color: #999;
    font-size: 14px;
  }

  .event-type-tabs {
    display: inline-flex;
    background: #f5f5f5;
    padding: 4px;
    border-radius: 8px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
  }

  .event-type-tab {
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    color: #666;

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }

    &.active {
      background: #fff;
      color: #2196f3;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    }
  }

  .condition-tag {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    color: #1890ff;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    position: relative;

    .optional-badge {
      position: absolute;
      top: -8px;
      right: -8px;
      font-size: 10px;
      background: #e0e0e0;
      color: #666;
      padding: 2px 6px;
      border-radius: 10px;
    }

    .remove-btn {
      cursor: pointer;
      opacity: 0.6;
      transition: opacity 0.2s;

      &:hover {
        opacity: 1;
        color: #f56c6c;
      }
    }
  }

  .add-field-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border: 1px dashed #d9d9d9;
    background: #fafafa;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #2196f3;
      border-color: #2196f3;
      background: #e6f7ff;
    }
  }

  .dropdown-menu {
    position: absolute;
    left: 0;
    top: 100%;
    margin-top: 8px;
    width: 192px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 20;
    overflow: hidden;
  }

  .dropdown-item {
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    font-size: 14px;
    color: #333;
    border: none;
    background: none;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
      color: #2196f3;
    }
  }

  .filter-footer {
    background: #fafafa;
    padding: 16px 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    border-radius: 0 0 12px 12px;
  }

  .preview-section {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8e8e8;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .preview-header {
    background: #fafafa;
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .preview-title {
    display: flex;
    align-items: center;
    gap: 8px;

    h2 {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin: 0;
    }
  }

  .preview-content {
    padding: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .data-summary {
    /* margin-bottom: 16px; */
    display: flex;
    align-items: baseline;
    gap: 8px;

    .label {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .value {
      font-size: 24px;
      font-weight: 600;

      &.success {
        color: #2196f3;
      }
      &.error {
        color: #ff4d4f;
      }
    }

    .unit {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
  }

  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed #e8e8e8;
    border-radius: 12px;
    background: #fafafa;
    padding: 60px 20px;

    p {
      color: #999;
      font-weight: 500;
      margin: 0;
    }
  }

  .data-table-wrapper {
    flex: 1;
    border: 1px solid #e8e8e8;
    border-radius: 12px;
    overflow-x: auto;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .data-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
    text-align: left;
  }

  .preview-footer {
    background: #fafafa;
    padding: 16px 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: auto;
  }
`;

export default DataToolsStyled;
